import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DotsLoader = ({ marginTop = { xs: 8, sm: 12 } }) => {
  const theme = useTheme();

  const dots = [
    { delay: '0ms' },
    { delay: '100ms' },
    { delay: '200ms' },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop,
      }}
    >
      <Box
        role='status'
        aria-label='Lade…'
        sx={{
          '@keyframes dotBounce': {
            '0%':   { transform: 'translateY(0px)',   opacity: 0.25 },
            '6%':   { transform: 'translateY(-18px)', opacity: 1    },
            '12%':  { transform: 'translateY(0px)',   opacity: 0.25 },
            '24%':  { transform: 'translateY(0px)',   opacity: 0.25 },
            '30%':  { transform: 'translateY(-18px)', opacity: 1    },
            '36%':  { transform: 'translateY(0px)',   opacity: 0.25 },
            '52%':  { transform: 'translateY(0px)',   opacity: 0.25 },
            '66%':  { transform: 'translateY(-18px)', opacity: 1    },
            '80%':  { transform: 'translateY(0px)',   opacity: 0.25 },
            '100%': { transform: 'translateY(0px)',   opacity: 0.25 },
          },
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '18px',
        }}
      >
        {dots.map((dot, i) => (
          <Box
            key={i}
            sx={{
              width: 14,
              height: 14,
              borderRadius: '50%',
              backgroundColor: theme.palette.grey[700],
              animation: `dotBounce 4000ms ease-in-out infinite`,
              animationDelay: dot.delay,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default DotsLoader;
